export default __webpack_public_path__ + "static/media/555.15cb8c16.jpg";